"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = void 0;
const react_1 = __importStar(require("react"));
function Property({ label, value, onChange }) {
    const [val, setVal] = react_1.useState(value);
    react_1.useEffect(() => {
        setVal(value);
    }, [value]);
    return react_1.default.createElement("label", null,
        react_1.default.createElement("span", { className: "label" }, label),
        " ",
        react_1.default.createElement("input", { value: val, onChange: el => setVal(el.target.value), onBlur: ev => onChange(val) }));
}
exports.Property = Property;
